<script>
	import { imageLightbox, imageLightboxCaptions } from "src/store/store";
	import Lightbox from "../../../components/Lightbox/Lightbox.svelte";
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";

	export let detailData;

	let {
		job: { preInspection },
	} = detailData;

	const flatImages = Object.entries(preInspection)
		.filter(([, section]) => section?.media?.length > 0)
		.flatMap(([key, section]) =>
			section.media.map((media) => ({
				url: media.url,
				key,
				caption: media.caption,
				hasDamage: section.hasDamage,
			}))
		);

	let modalOpen = false;
	let imgIndex = 0;

	function handleOpenImage(index) {
		imgIndex = index;
		imageLightbox.set(flatImages.map((img) => img.url));
		imageLightboxCaptions.set(flatImages.map((img) => img.caption));
		modalOpen = true;
	}
</script>

{#if modalOpen}
	<Lightbox
		imageShowingIndex={imgIndex}
		on:click={() => (modalOpen = false)}
	/>
{/if}
<div class="d-flex">
	{#each flatImages as img, index}
		<div class="me-3">
			<div class="img-wrapper">
				<img
					class="inspect-img"
					src={img.url}
					alt="job-inspection"
					on:click={() => handleOpenImage(index)}
					on:keydown={() => {}}
				/>
				{#if img.hasDamage}
					<span
						class="damage-badge bg-danger rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
						>!</span
					>
				{/if}
			</div>
			<div class="d-flex justify-content-center mt-2">
				<span>{splitCamelCaseAndCapitalize(img.key)}</span>
			</div>
		</div>
	{/each}
</div>

<style>
	.inspect-img {
		width: 160px;
		height: 160px;
		border-radius: 8px;
		margin-right: 0;
	}

	.img-wrapper {
		position: relative;
		display: inline-block;
	}
	.damage-badge {
		position: absolute;
		top: -6px;
		right: -6px;
		width: 18px;
		height: 18px;
		font-size: 11px;
	}
</style>
